module.exports = __webpack_public_path__ + "static/pinduksite-e45079e9a42de259be9e5a475154198a.webp";